import type { JSX } from 'react'

import {
  BufferIcon,
  ChannelIcon,
  CheckIcon,
  CopyIcon,
} from '@buffer-mono/popcorn'
import type { ChannelIconProps } from '@buffer-mono/popcorn'

import styles from './PublicShareNowArt.module.css'

const ART_NETWORKS: readonly ChannelIconProps['type'][] = [
  'instagram',
  'linkedin',
  'facebook',
]

const BUFFER_ROUTES = [
  'M38 50 H58',
  'M58 50 C68 50 68 18 80 18',
  'M58 50 H80',
  'M58 50 C68 50 68 82 80 82',
] as const

const MANUAL_ROUTES = [
  'M38 50 C58 50 62 18 80 18',
  'M38 50 H80',
  'M38 50 C58 50 62 82 80 82',
] as const

function ArtPost(): JSX.Element {
  return (
    <span className={styles.post}>
      <span className={styles.postMedia} />
      <span className={styles.postLine} />
      <span className={`${styles.postLine} ${styles.postLineShort}`} />
    </span>
  )
}

function ArtNetworks({ delivered }: { delivered: boolean }): JSX.Element {
  return (
    <>
      {ART_NETWORKS.map((network, index) => (
        <span
          key={network}
          className={styles.network}
          data-position={index}
          data-delivered={delivered}
        >
          <ChannelIcon type={network} color="subtle" size="small" />
          <span className={styles.tick}>
            <CheckIcon size={10} />
          </span>
        </span>
      ))}
    </>
  )
}

export function PublicShareNowArt({
  variant,
}: {
  variant: 'buffer' | 'manual'
}): JSX.Element {
  const routes = variant === 'buffer' ? BUFFER_ROUTES : MANUAL_ROUTES

  return (
    <div className={styles.stage} data-variant={variant} aria-hidden="true">
      <svg
        className={styles.routes}
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        {routes.map((route) => (
          <path
            key={route}
            d={route}
            className={styles.route}
            vectorEffect="non-scaling-stroke"
          />
        ))}
      </svg>
      <ArtPost />
      {variant === 'buffer' ? (
        <span className={styles.relay}>
          <BufferIcon size="small" />
        </span>
      ) : (
        <span className={styles.chip}>
          <CopyIcon size={14} />
        </span>
      )}
      <ArtNetworks delivered={variant === 'buffer'} />
    </div>
  )
}
